export default __webpack_public_path__ + "1320df01975afb9d39dd1adebbeaf324.svg";